export default {
  // tabs
  automationTab: "_A_utomation",
  browseContentTab: "Browse _C_ontent",
  browseTemplatesTab: "Browse _T_emplates",
  completedGraphicsTab: "Completed G_r_aphics",
  dataTab: "_D_ata",
  graphicTemplatesTab: "_G_raphic Templates",
  imagesTab: "_I_mages",
  luciTab: "LUCI",
  moviesTab: "_M_ovies",
  runningOrdersTab: "Rund_o_wns",
  savedItemsTab: "Saved Items",
  saveToDiskTab: "Save to Disk",
  studioClipsTab: "Studio C_l_ips",
  // titles
  channelHeader: "C_h_annel",
  compositorOverlayTitle: "Compose Image",
  confirmTitle: "Confirm",
  deleteSavedItemDialogTitle: "Delete Saved Item",
  editModeTitle: "Edit Mode",
  folderOperationTitleFormat: "{operation} Folder",
  infoDialogTitle: "Information Dialog",
  licenseDialogTitle: "License Agreement",
  localHeader: "Local",
  loginTitle: "LUCI Login",
  orderImageOverlayTitle: "Order Image",
  orderMovieOverlayTitle: "Order Movie",
  publishTitle: "Publish",
  renderMediaTitle: "Render Media",
  saveItemTitle: "Save Item",
  slugHeader: "S_l_ug",
  storyListTitle: "Story List",
  templatesOverlayTitle: "Templates",
  timecodeHeader: "Timeco_d_e",
  // labels
  authorLabel: "Author:",
  automationTransitionsLabel: "Automation Transitions:",
  primeStylesLabel: "Prime Styles:",
  axisServicesLabel: "Axis Services:",
  axisStatusLabel: "Axis Status:",
  camioServerLabel: "CAMIO Server:",
  camioStatusLabel: "CAMIO Server Status:",
  camioVersionLabel: "CAMIO Version:",
  connectedLabel: "Connected",
  contextLabel: "Co_n_text:",
  createdLabel: "Created",
  descriptionLabel: "Description:",
  disconnectedLabel: "Disconnected",
  durLabel: "Dur",
  durationLabel: "Duration",
  filenameLabel: "Filename*",
  filterLabel: "_F_ilter:",
  folderVisibilityLabel: "Folder can be seen by:",
  inLabel: "In",
  keywordsLabel: "Keywords:",
  lastUploadedLabel: "Last Uploaded:",
  layerLabel: "Layer",
  licensedLabel: "(Licensed)",
  licensedOptionsLabel: "Licensed Options:",
  luciCategoryLabel: "Asset Category",
  luciContextLabel: "Context",
  luciFolderLabel: "Folder",
  luciVersionLabel: "LUCI Version:",
  mediaEngineServerLabel: "Media Renderer Server:",
  mediaEngineStatusLabel: "Media Renderer Server Status:",
  mediaFieldsLabel: "Image/Video Fields:",
  notConfiguredLabel: "Not Configured",
  outLabel: "Out",
  presetLabel: "Choose Preset to Save to",
  publishAsLabel: "Publish as",
  publishingServerLabel: "Publishing Server:",
  publishingStatusLabel: "Publishing Server Status:",
  renderAsLabel: "Render as",
  saveAsLabel: "Save as",
  savedItemExpirationLabel: "Items will be saved:",
  saveItemFolderLabel: "Please enter a name for the new folder",
  saveItemFolderRenameLabelFormat:
    "Please enter a new name for the folder '{folderName}'",
  selectedContentLabel: "Selected Content",
  sizeLabel: "Size:",
  sortLabel: "Sort:",
  storyNameLabel: "Story Name*",
  subjectLabel: "Subject:",
  filenameLabel: "Filename:",
  textFieldsLabel: "Text Fields:",
  titleLabel: "Title:",
  typeLabel: "Type:",
  unlicensedLabel: "(Not Licensed)",
  usernameLabel: "Username:",
  dragReady: "Drag Ready!",
  // buttons
  cancelButton: "Cancel",
  changeUserButton: "Change User",
  closeButton: "Close",
  closeEditorButton: "Close Editor",
  composeButton: "Com_p_ose Tool",
  composeImageButton: "Com_p_ose Image",
  composeMovieButton: "Com_p_ose Movie",
  dismissButton: "DISMISS",
  downloadButton: "Download",
  insertButton: "_I_nsert",
  licenseAgreementButton: "License Agreement",
  logInButton: "Login",
  logOutButton: "Log Out",
  okButton: "OK",
  orderImageButton: "O_r_der Image",
  orderMovieButton: "O_r_der Movie",
  playButton: "PLAY",
  previewButton: "Generate Preview",
  modifyButton: "_M_odify Current",
  postButton: "Post Now",
  publishButton: "Pu_b_lish",
  publishLoginButton: "Log In to Post",
  reloadButton: "Click to Reload",
  renderMediaButton: "Render Media",
  replaceButton: "_R_eplace",
  replaceWithNewButton: "_R_eplace with New",
  saveButton: "Save",
  saveItemButton: "Save Item",
  saveToLuciButton: "Save to LUCI",
  submitButton: "Submit",
  swapTemplatesButton: "Swap Templates",
  viewButton: "VIEW",
  // placeholders
  filenamePlaceholder: "Filename",
  folderNamePlaceholder: "Folder Name",
  searchAutomationPlaceholder: "Search Automation",
  searchCompletedGraphicsPlaceholder: "Search Completed Graphics",
  searchGraphicTemplatesPlaceholder: "Search Graphic Templates",
  searchImagesPlaceholder: "Search Images",
  searchMoviesPlaceholder: "Search Videos",
  searchPlaceholder: "Search",
  searchStudioClipsPlaceholder: "Search Studio Clips",
  storyNamePlaceholder: "Placeholder",
  timecodeFramePlaceholder: "ff",
  timecodeHrPlaceholder: "hh",
  timecodeMinPlaceholder: "mm",
  timecodeSecPlaceholder: "ss",
  usernamePlaceholder: "Username",
  // select options
  favoriteOption: "Favorites",
  noneOption: "None",
  selectContextOption: "Select Context",
  selectRunningOrderOption: "Select Running Order",
  showAllOption: "Show all",
  sortByDateAscOption: "Least Recent",
  sortByDateDescOption: "Most Recent",
  sortByNameAscOption: "A - Z",
  sortByNameDescOption: "Z - A",
  todayOption: "Today",
  withoutPreviewOnlyOption: "Download without Preview Only Images",
  withPreviewOnlyOption: "Download with Preview Only Images",
  yesterdayOption: "Yesterday",
  // folders
  dayFolder: "24 Hours",
  globalFolder: "Global",
  neverExpiringFolder: "Never Expiring",
  userFolder: "User",
  weekFolder: "7 Days",
  // errors
  characterLimitErrorFormat:
    "Posts are limited to {max} characters. You have typed {currentLength} characters.",
  mosObjectCreateError: "Mos Object creation failed.",
  presetUnavailableError: "*Render Engine preset is no longer available.",
  previewError: "Preview generation failed. Please try again.",
  proxyUnavailableError: "Proxy is unavailable",
  renderMediaDestinationError:
    "Please set up Render Media Destinations in CAMIO to choose a preset.",
  requiredFilenameError: "Filename is required",
  requiredFolderNameError: "Folder name cannot be blank.",
  requiredPresetError: "Preset is required",
  requiredStoryNameError: "Story Name is required",
  // text
  confirmDeleteSavedItemText:
    "Are you sure you want to delete the selected saved item?",
  confirmDeleteFolderFormat:
    "Are you sure you want to delete the folder '{folderName}' and all of its contents? This action cannot be undone.",
  emptyFolderText: "Folder is empty",
  emptyResultsText: "No results found.",
  enlargeTooltip: "Double click to enlarge",
  exitClipperText: "EXIT EDITOR TO RETURN TO LUCI",
  facebookPostSuccess: "Submitted post to Facebook.",
  folderVisibilityAllText: "All Users",
  folderVisibilityOtherText: "Someone Else",
  folderVisibilityYouText: "Just You",
  imageText: "Image",
  linkedDataSourceTooltip: "Data linked. Click to break link.",
  loggedInFormat: "Logged in as {user}",
  mosItemSuccessFormat: "Item {objId} successfully created.",
  movieText: "Movie",
  savedItemExpirationDayText: "For 24 Hours",
  savedItemExpirationManualText: "Until Manual Deletion",
  savedItemExpirationWeekText: "For 7 Days",
  savedToLuciText: "Item saved to luci.",
  timecodeMaxFormat: " ({max}s max)",
  twitterPostSuccess: "Submitted post to Twitter.",
  unlinkedDataSourceTooltip: "Data not linked. Click to link."
};



// WEBPACK FOOTER //
// ./public/js/resources/en/main.js